<template>
  <div class="floor7-wrapper">
    <div class="floor7-content clearfloat">
      <div class="left">
        <div class="title">
          <img src="~images/floor7/title.png" alt />
        </div>
        <div class="desc">
          <img src="~images/floor7/desc1.png" alt />
          <!--<div class="de">斑马会员是杭州迅兰电子商务有限公司旗下电商平台，内容涉及3C家电、家居生活、时尚运动、海淘、旅游等生活消费全领域。为消费者提供高性价比的商品和服务，力求成为消费者心目中的“品质消费第一站”。-->
          <!--</div>-->
        </div>
        <div class="phone">
          <img src="~images/floor7/phone.png" alt />
        </div>
      </div>
      <div class="right">
        <div class="floor7-title">
          <img src="~images/floor7/seller.png" alt />
        </div>
        <div class="seller-partner">
          <p class="single">服务权益：yqhz@gegejia.com</p>
          <!--<p class="single">金融保险：jinrongbd@gegejia.com</p>-->
        </div>
        <!--<div class="floor7-title">-->
          <!--<img src="~images/floor7/business.png" alt />-->
        <!--</div>-->
        <div class="business-partner">
          <!--<div class="seller-partner">-->
            <!--<p class="single">business@gegejia.com</p>-->
          <!--</div>-->
          <div class="floor7-title">
            <img src="~images/floor7/media.png" alt />
          </div>
          <div class="seller-partner">
            <p class="single">media@gegejia.com</p>
          </div>
          <!--<div class="out-link">-->
            <!--<a href="https://weibo.com/u/6884061920" target="_blink">-->
              <!--<img class="out-link-img" src="~images/floor7/weibo.png" alt />-->
            <!--</a>-->
            <!--<span>斑马会员官方微博</span>-->
          <!--</div>-->
          <!--<div class="out-link">-->
            <!--<img class="out-link-img" src="~images/floor7/wechat.png" alt @click="codeCtrl" />-->
            <!--<span>斑马会员官方微信</span>-->
            <!--<div class="floor7-big-code" v-if="codeVisible">-->
              <!--<img src="~images/common/erweima.jpg" alt />-->
            <!--</div>-->
          <!--</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      codeVisible: false
    };
  },
  methods: {
    codeCtrl() {
      this.codeVisible = !this.codeVisible;
    }
  }
};
</script>

<style scoped lang="less">
.floor7-wrapper {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  background-image: url(~images/floor7/guanyubg.png);
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  font-size: 14px;
  .floor7-content {
    position: absolute;
    left: 0;
    top: 20%;
    width: 100%;
    display: flex;
    .left {
      // margin-top: 5%;
      margin-left: 7.5%;
      width: 29%;
      .title {
        width: 100%;
        img {
          width: 50%;
        }
      }
      .desc {
        margin-top: 60px;
        width: 100%;
        .de{
          color: #fff;
          font-weight: 300;
          font-size: 12px;
        }
        img {
          width: 100%;
        }
      }
      .phone {
        width: 394px;
        margin-top: 60px;
      }
    }
    .right {
      margin-left: 17%;
      .floor7-title {
        margin-bottom: 18px;
        img {
          width: 125px;
        }
      }
      .seller-partner {
        color: #fff;
        margin-bottom: 51px;
        .single {
          margin: 0;
          line-height: 24px;
        }
      }
      .business-partner {
        color: #fff;
        .single {
          font-family: "DIN";
          margin-bottom: 20px;
          color: #fff;
        }
        .out-link {
          display: flex;
          align-items: center;
          position: relative;
          .out-link-img {
            width: 40px;
            height: 40px;
            margin-right: 16px;
            cursor: pointer;
          }
          .floor7-big-code {
            position: absolute;
            left: 56px;
            top: 10px;
            img {
              border-radius: 0 20px 20px 20px;
              width: 165px;
              height: 165px;
            }
          }
        }
      }
    }
  }

  .clearfloat:after {
    content: "";
    display: block;
    clear: both;
  }
  .clearfloat {
    zoom: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/floor/floor_7.vue